<main>
  <div class="card">
    <h1><i class="fa fa-envelope-o fa-3x"></i></h1>
    <h2>Verifique seu e-mail</h2>
    <p>Enviamos as instruções para alteração de senha para: </p>
    <b>{{ email }}</b>
    <a [routerLink]="['/']">Efetuar login</a>
  </div>
</main>
